export default __webpack_public_path__ + "static/4-ef965a260e43005b05aa2f242499ea26.jpg";